export const MAXIMUM_TIRES = 8;
export const MAXIMUM_MOUNTED_WHEELS = 24;
export const TIRE_DEFAULT_QTY = 1;
export const SERVICE_DEFAULT_QTY = 1;
export const WAITING_APPOINTMENT_TYPE = 'waiting';
export const MOBILE_APPOINTMENT_TYPE = 'is_mobile';
export const MOUNTED_WHEEL_APPOINTMENT_TYPE = 'mounted_wheel';
export const DROPOFF_APPOINTMENT_TYPE = 'dropoff';
export const PQL_MOUNTING_WHEEL = 'S0501';
export const INSTALLATION_SCODES = ['S1325', 'S1326', 'S1327', 'S1328'];
export const INSTALLATION_TPMS = 'S1329';
